import { getRequestService } from "../RequestService";
import { GlobalConfig } from "../configuration";
import { AjaxService } from "sb-helpers";
import { ApplicationEnum } from "../types";
import { PlatformRequestGateway } from "../PlatformRequestGateway";
import { SeamlessRequestGateway } from "../SeamlessRequestGateway";
import { WalletRequestGateway } from "../WalletRequestGateway";
const RequestGatewayMapper = {
    [ApplicationEnum.Platform]: (requestService) => new PlatformRequestGateway(requestService),
    [ApplicationEnum.Seamless]: (requestService) => new SeamlessRequestGateway(requestService),
    [ApplicationEnum.Wallet]: (requestService) => new WalletRequestGateway(requestService)
};
export function apiRequestGatewayFactory(globalConfig) {
    if (!RequestGatewayMapper[globalConfig.config.applicationType]) {
        throw `Not supported application type ${globalConfig.config.applicationType}`;
    }
    const requestService = getRequestService(globalConfig.config.applicationType, globalConfig.config.apiVersion, globalConfig.config.anonymousApiUrl, globalConfig.config.siteID, globalConfig.config.operatorAuthTokenId, new AjaxService(), globalConfig.config.domainID);
    return RequestGatewayMapper[globalConfig.config.applicationType](requestService);
}
export const apiRequestGateway = apiRequestGatewayFactory.bind(this, GlobalConfig);
//# sourceMappingURL=ApiRequestGatewayFactory.js.map